export const bannerConstants = {
	TITLE: 'For added security, beginning March 4, 2025, you must login using your Ascension email.',
	POST_RELEASE_TITLE: 'Please login with your Ascension email today.',
	SUB_TITLE: 'This email will not be used for communications. You will not receive emails to this address.',
	BODY_TITLE: 'Copy your Ascension email address for future logins.',
};

